import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
	root: {},
	openingCard: {
		marginTop: theme.spacing(5),
	},
}));
